import { API_PATHS } from "../../paths";
import axios from "axios";
import Regions from "../../Model/RegionsModel";

export async function RegionsCardData() {
  try {
    const token = localStorage.getItem('authToken');
    const response = await axios.get(
      API_PATHS.regions,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Format the data using the Regions model
    const formattedData = response.data.regions.map(region => new Regions(
      region._id,
      region.cityId,
      region.city,
      region.state,
      region.imageURL,
      region.industries,
      region.individuals,
      region.contact
    ));

    return formattedData;
  } catch (error) {
    throw error;
  }
}